import { cn } from '@/utils/cn'
import type { HTMLAttributes } from 'react'
import { LoadingIcon } from '../icons/loading'

export const Loader = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <LoadingIcon size={24} className="animate-spin" />
      <span>Loading...</span>
    </div>
  )
}
